interface FrPillProps {
  label: string;
}

export function FrPill({ label }: FrPillProps) {
  return (
    <span className="inline-flex items-center rounded-full bg-info/15 px-2 py-0.5 font-mono text-[11px] font-semibold uppercase tracking-wide text-info-text ring-1 ring-info/30">
      {label}
    </span>
  );
}
